// Dev-only console helpers. In production these are no-ops so we don't leak
// stack traces or noisy logs to end-user devtools. Use these instead of
// raw console.error / console.warn in cart, hooks and customer pages.

export function devError(...args: unknown[]): void {
  if (import.meta.env.DEV) {
    // eslint-disable-next-line no-console
    console.error(...args);
  }
}

export function devWarn(...args: unknown[]): void {
  if (import.meta.env.DEV) {
    // eslint-disable-next-line no-console
    console.warn(...args);
  }
}
